import i18n, { resources, defaultLanguage } from '../i18n'

export const getLanguage = () => {
  const currentLanguage = i18n.language
  const resource = resources[currentLanguage]

  return resource ? currentLanguage : defaultLanguage
}
